import { EditorView } from '@codemirror/view';
export var scrollerTheme = EditorView.theme({
  '& .cm-scroller': {
    height: '100% !important'
  }
});
var lastDimensionKey = null;
var lastDimensionTheme = null;
export function getDimensionTheme(height, minHeight, maxHeight, width, minWidth, maxWidth) {
  if (!height && !minHeight && !maxHeight && !width && !minWidth && !maxWidth) {
    return null;
  }
  var cacheKey = JSON.stringify({
    height,
    minHeight,
    maxHeight,
    width,
    minWidth,
    maxWidth
  });
  if (cacheKey === lastDimensionKey) {
    return lastDimensionTheme;
  }
  lastDimensionKey = cacheKey;
  lastDimensionTheme = EditorView.theme({
    '&': {
      height,
      minHeight,
      maxHeight,
      width,
      minWidth,
      maxWidth
    }
  });
  return lastDimensionTheme;
}